import API from "./api";

/**
 * Get all master data
 */
export const getMasters = () => {
    return API.get("/masters");
};

/**
 * Save Article / Job Title / Material
 */
export const saveMaster = (data) => {
    return API.post("/masters/save", data);
};

/**
 * Delete Article / Job Title / Material
 */
export const deleteMaster = (data) => {
    return API.post("/masters/delete", data);
};